export default "__VITE_ASSET__CQTi_NYE__"